import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Input } from '../ui/input';
import { GRUPO, fmtDate, clientUrl } from '../client360/c360Shared';

export const ClientsPanel = ({ clientes, total, leads }) => {
  const [q, setQ] = useState('');
  const t = q.trim().toLowerCase();
  const list = t ? clientes.filter((c) => (c.nome || '').toLowerCase().includes(t) || (c.nif || '').includes(t)) : clientes;
  return (
    <div className="grid gap-4 lg:grid-cols-[1fr_320px]">
      <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3" data-testid="com360-clients">
        <div className="flex flex-wrap items-center gap-3">
          <h2 className="text-base md:text-lg font-bold font-[Outfit] text-[#2D3E6F] flex-1">Os clientes dele ({total})</h2>
          <div className="relative w-56">
            <Search className="w-3.5 h-3.5 absolute left-2.5 top-2.5 text-slate-400" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nome ou NIF" className="h-8 pl-8 text-sm" data-testid="com360-clients-search" />
          </div>
        </div>
        {list.length === 0 ? <div className="text-sm text-slate-400 py-6 text-center">Sem clientes.</div> : (
          <div className="divide-y divide-slate-100 max-h-80 overflow-y-auto">
            {list.map((c, i) => (
              <Link key={c.nif || c.nome || i} to={clientUrl(c.nif, c.nome, { contractId: c.contract_id })} data-testid={`com360-client-${i}`}
                className="flex items-center gap-3 py-2 px-1 text-sm hover:bg-slate-50 rounded">
                <span className="flex-1 truncate font-medium">{c.nome}</span>
                <span className="font-mono text-xs text-slate-500">{c.nif || 'sem NIF'}</span>
                <span className="hidden sm:flex gap-1">{c.servicos.map((s) => <span key={s} className={`text-[10px] px-1.5 rounded-full border ${GRUPO[s]?.cls}`}>{GRUPO[s]?.label}</span>)}</span>
                <span className="text-xs text-slate-400 w-16 text-right">{c.contratos} contr.</span>
                <span className="text-xs text-slate-400 w-20 text-right hidden md:block">{fmtDate(c.ultimo)}</span>
              </Link>
            ))}
          </div>
        )}
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-2" data-testid="com360-leads-kpis">
        <h2 className="text-base md:text-lg font-bold font-[Outfit] text-[#2D3E6F]">Leads atribuídas</h2>
        {[['Total', leads.total], ['Aguardam 1º contacto', leads.aguarda_contacto], ['Em curso', leads.em_curso], ['Paradas +24h', leads.parada], ['A expirar', leads.a_expirar], ['Expiradas 42h', leads.expirada], ['Conversão', `${leads.conv_pct}%`]].map(([l, v]) => (
          <div key={l} className="flex justify-between text-sm"><span className="text-slate-600">{l}</span><b>{v}</b></div>
        ))}
      </div>
    </div>
  );
};
